<template>
  <div class="rt-date-picker" @mouseenter="mouseEnter" @mouseleave="mouseLeave">
    <el-date-picker
      :value="inputValue"
      v-bind="$attrs"
      :type="type"
      :disabled="disabled"
      :readonly="readonly"
      @input="inputHandler"
    ></el-date-picker>
    <rt-icon slot="suffix" :name="icon" @click="clear" />
  </div>
</template>

<script>
export default {
  name: 'RtDatePicker',
  props: {
    value: {
      type: [Date, String]
    },
    type: {
      type: String,
      default: 'date'
    },
    datafieldname: String,
    disabled: {
      type: Boolean,
      default: false,
      required: false
    },
    readonly: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  data() {
    return {
      inputValue: null,
      hover: false
    };
  },
  computed: {
    icon() {
      return this.hover && this.value ? 'rt-base-close' : 'rt-base-date';
    }
  },
  watch: {
    value(newVal) {
      if (newVal) {
        this.inputValue = new Date(newVal);
      } else {
        this.inputValue = null;
      }
    }
  },
  created: function() {
    if (this.value) {
      this.inputValue = new Date(this.value);
    }
  },
  methods: {
    inputHandler(newValue) {
      this.inputValue = newValue;
      this.$emit('input', newValue, null, this.datafieldname);
    },
    mouseEnter() {
      if (this.disabled) {
        this.hover = false;
      } else {
        this.hover = true;
      }
    },
    mouseLeave() {
      this.hover = false;
    },
    clear() {
      if (this.hover) {
        this.$emit('input', '', null, this.datafieldname);
      }
    }
  }
};
</script>

<style lang="less">
.rt-date-picker {
  position: relative;
  .rt-icon {
    position: absolute;
    right: 0;
    top: 0;
    color: #dbe0f3;
  }
  .el-date-editor {
    &.el-input {
      width: 100%;
    }

    .el-input__prefix,
    .el-input__suffix {
      display: none;
    }
    .el-input__inner {
      padding: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// rtDatePicker.vue?04a9684a